@if (isVisible) {
    <div>
        <ng-content></ng-content>
    </div>
}
